import { useCallback, useContext } from "react";
import { AuthContext } from "../../auth/components/provider";


const SignIn = () => {
  const client = useContext(AuthContext);
  const production = process.env.REACT_APP_GRAPHQL_URL?.includes("prod");

  const handleSignIn = useCallback(
    async (provider: string) => {
      try {
        await client.signIn({
          provider: provider as any,
          options: {
            redirectTo: "/",
          },
        });
      } catch (error) {
        console.error("Error during sign-in:", error);
      }
    },
    [client]
  );



  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="p-8 max-w-md w-full bg-white shadow-lg rounded-lg">
        {production && (
          <div className="flex items-center justify-center mb-4">
            <span className="text-2xl font-bold font-mono text-red-500">Production Environment</span>
          </div>
        )}
        <h2 className="text-2xl font-bold text-center mb-8 text-gray-800">KaKtu Admin Panel</h2>
        <button onClick={() => handleSignIn("google")} className="flex items-center justify-center w-full p-3 mb-4 bg-white hover:bg-gray-50 text-gray-700 font-semibold rounded-lg border border-gray-300 shadow-sm transition duration-300 ease-in-out">
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          Sign in with Google
        </button>
        {!production && (
          <button onClick={() => handleSignIn("oidc")} className="flex items-center justify-center w-full p-3 bg-[#1A1F36] hover:bg-[#2A2F46] text-white font-semibold rounded-lg shadow-sm transition duration-300 ease-in-out">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 2c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z" />
            </svg>
            Sign in with Keycloak
          </button>
        )}
      </div>
    </div>
  );
};

export default SignIn;
